import { ActionIcon, Menu } from '@mantine/core';
import { IconDotsVertical, IconTransfer } from '@tabler/icons-react';
import type { MouseEvent } from 'react';

function stopRowActivation(e: React.KeyboardEvent) {
  if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
}

interface CaseloadRowActionsMenuProps {
  onTransfer: (event: MouseEvent) => void;
}

/** 3-dot row menu shared by caseload tables (Transfer). */
export function CaseloadRowActionsMenu({
  onTransfer,
}: CaseloadRowActionsMenuProps): JSX.Element {
  return (
    <Menu shadow="md" width={180} position="bottom-end">
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          aria-label="Row actions"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={stopRowActivation}
        >
          <IconDotsVertical size={16} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item leftSection={<IconTransfer size={16} />} onClick={onTransfer}>
          Transfer
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
